import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import './OrderImages.scss';

const OrderImages = ({ isCancelled, items }) => {
  return (
    <div className={cx('order-images', {
      'order-images--cancelled': isCancelled
    })}>
      {items.map(({ type, id, label, productSku, image = {}, backgroundColor }) => {
        const isItemLabel = type === 'label';
        const hasBackgroundColor = !isItemLabel && backgroundColor;
        return (
          <div
            key={`image_${type}_${id}`}
            className={cx('order-images__image', {
              'order-images__image--label': isItemLabel
            })}
            style={{ backgroundColor: hasBackgroundColor ? backgroundColor : '#f5f5f0' }}
            data-product-sku={productSku}>
            {isItemLabel && label && <p>{label}</p>}
            {!isItemLabel && image.url && <img src={image.url} alt={image.alt} />}
          </div>
        );
      })}
    </div>
  );
};

OrderImages.propTypes = {
  isCancelled: PropTypes.bool.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.string.isRequired,
    backgroundColor: PropTypes.string,
    label: PropTypes.string,
    id: PropTypes.number.isRequired,
    image: PropTypes.object,
  }))
};

export default OrderImages;



// WEBPACK FOOTER //
// ./src/client/js/view/components/Order/OrderImages/OrderImages.js